import { useCallback, useEffect, useState } from "react";
import api from "./api";
import { useAuth } from "@/context/AuthContext";

export function useMaster() {
  const { user } = useAuth();
  const [products, setProducts] = useState([]);
  const [allWarehouses, setAllWarehouses] = useState([]);

  const reload = useCallback(() => {
    api.get("/products").then((r) => setProducts(r.data)).catch(() => {});
    api.get("/warehouses").then((r) => setAllWarehouses(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  const assigned = user?.warehouse_ids || [];
  const warehouses = assigned.length > 0 ? allWarehouses.filter((w) => assigned.includes(w.id)) : allWarehouses;

  return {
    products,
    warehouses,
    reload,
    productMap: Object.fromEntries(products.map((p) => [p.id, p])),
    warehouseMap: Object.fromEntries(allWarehouses.map((w) => [w.id, w])),
  };
}
